import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { gossipCategories } from "@/mocks/gossipCategories";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <title>页面走丢了 | 瓜料动态</title>
      <meta name="robots" content="noindex, follow" />
      <Layout>
        <div className="mx-auto flex max-w-shell flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
          <span className="flex h-16 w-16 items-center justify-center rounded-lg bg-primary-100 font-heading text-3xl font-bold text-primary-600">
            瓜
          </span>
          <p className="mt-6 font-heading text-5xl font-bold text-foreground-950 md:text-6xl">404</p>
          <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">这条瓜好像被搬走了</h1>
          <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
            你访问的页面不存在或已经调整过地址。可以回到首页继续刷今日更新，或者从下面的栏目直接进入。
          </p>
          <p className="mt-2 text-xs text-foreground-400">{location.pathname}</p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              回到首页
            </Link>
            <Link
              to="/faq"
              className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              查看常见问题
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap justify-center gap-2">
            {gossipCategories.map((category) => (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className="rounded-full bg-background-100 px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200"
              >
                {category.name}
              </Link>
            ))}
          </div>
        </div>
      </Layout>
    </>
  );
}